import type { Sensors } from '@dnd-kit/dom';
import { PointerActivationConstraints, PointerSensor } from '@dnd-kit/dom';

/**
 * The sensor set `Board` and `TileRack` provision for themselves when `standalone`, and the one a
 * parent composing them under its own `DragDropProvider` should supply — tile drags behave the same
 * either way only if the activation constraint matches.
 *
 * Pointer only, deliberately: both components implement their own keyboard drag (grid-aware moves,
 * `R` to rotate), which dnd-kit's `KeyboardSensor` would fight over the same Space/Enter/arrow keys.
 *
 * Every pointer takes `Distance` alone: 5px of movement starts the drag. A press-and-release that
 * never travels that far is a click or tap, which turns the tile — it must not lift the tile first,
 * as a hold-to-drag `Delay` would for a click that lingers past it. `Delay` also abandons the press
 * outright if the pointer strays before its timer fires, so a drag begun in one motion — a flick, or
 * a finger on a `touch-action: none` tile — left the tile where it was.
 *
 * A module constant rather than a hook: dnd-kit re-installs the manager's sensors whenever the
 * array's identity changes.
 */
export const tilePointerSensors: Sensors = [
  PointerSensor.configure({
    activationConstraints: [new PointerActivationConstraints.Distance({ value: 5 })],
  }),
];
